// Module
var code = `<div class="auto-hide-panel">
    <div class="auto-hide-panel-container">
        {{yield}}
    </div>
    {{#if .isShowMoreButton}}
        <terceraButton terceraButtonStyle="js-more-button"
                   name="viewMoreHorizontal"
                   SVG="true"
                   on-btnClick="onMoreButtonClicked"
                   checked="{{isAutoHideMenuOpen}}"/>
    {{/if}}
</div>`;
// Exports
export default code;